var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7176 0.000392361C21.7599 0.00948611 19.8905 0.176455 18.2455 0.467549C13.3997 1.32367 12.5199 3.11552 12.5199 6.42011V10.7845H23.9711V12.2392H12.5199H8.22226C4.89423 12.2392 1.98001 14.2395 1.06857 18.0449C0.0171669 22.4067 -0.0294268 25.1287 1.06857 29.6831C1.8826 33.0732 3.82651 35.4888 7.15454 35.4888H11.0918V30.2569C11.0918 26.4772 14.362 23.1432 18.2455 23.1432H29.6835C32.8675 23.1432 35.4091 20.5217 35.4091 17.3242V6.42011C35.4091 3.3168 32.791 0.985517 29.6835 0.467549C27.7164 0.14008 25.6752 -0.00870139 23.7176 0.000392361ZM17.5248 3.51058C18.7076 3.51058 19.6735 4.49233 19.6735 5.69936C19.6735 6.90217 18.7076 7.87483 17.5248 7.87483C16.3377 7.87483 15.376 6.90217 15.376 5.69936C15.376 4.49224 16.3377 3.51058 17.5248 3.51058Z",
    fill: "url(#paint0_linear_748_1186)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8376 12.2392V17.3242C36.8376 21.2666 33.4952 24.5847 29.6839 24.5847H18.246C15.1129 24.5847 12.5203 27.2661 12.5203 30.4037V41.3078C12.5203 44.4111 15.2189 46.2365 18.246 47.1269C21.8708 48.1927 25.3469 48.3854 29.6839 47.1269C32.5668 46.2922 35.4095 44.6124 35.4095 41.3078V36.9434H23.9715V35.4886H35.4095H41.1352C44.4632 35.4886 45.7035 33.1673 46.8609 29.683C48.0565 26.0959 48.0056 22.6464 46.8609 18.0448C46.0384 14.7316 44.4675 12.239 41.1352 12.239H36.8376V12.2392ZM30.4047 39.8531C31.5917 39.8531 32.5534 40.8257 32.5534 42.0285C32.5534 43.2357 31.5917 44.2174 30.4047 44.2174C29.2218 44.2174 28.2559 43.2357 28.2559 42.0285C28.2558 40.8257 29.2217 39.8531 30.4047 39.8531Z",
    fill: "url(#paint1_linear_748_1186)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_748_1186",
    x1: -0.859872,
    y1: 1.36506,
    x2: 25.5515,
    y2: 23.8885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_748_1186",
    x1: 35.4893,
    y1: 37.8893,
    x2: 26.0179,
    y2: 24.6069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPython);
export default __webpack_public_path__ + "static/media/icon_python.7d02a92bdd3f798e02b71b0dbbff219d.svg";
export { ForwardRef as ReactComponent };